import { useParams } from 'react-router-dom';

import EditOfferingSessionRuleSetForm from './components/editOfferingSessionRuleSetPage/EditOfferingSessionRuleSetForm';

import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';
import BackButton from '@/components/common/BackButton';

import { useOffering } from '@/data/offering';
import { useOfferingSessionRuleSet } from '@/data/offeringSessionRuleSet';
import { useOfferingSessionRules } from '@/data/offeringSessionRule';

const EditOfferingSessionRuleSetPage = () => {
  const params = useParams();
  const offering = useOffering(params.offeringId);
  const offeringSessionRuleSet = useOfferingSessionRuleSet(
    params.offeringSessionRuleSetId
  );
  const offeringSessionRules = useOfferingSessionRules(
    params.offeringSessionRuleSetId
  );

  if (offering.isLoading && !offering.data) {
    return <PageLoading />;
  }

  if (offeringSessionRuleSet.isLoading && !offeringSessionRuleSet.data) {
    return <PageLoading />;
  }

  if (offeringSessionRules.isLoading && !offeringSessionRules.data) {
    return <PageLoading />;
  }

  return (
    <Page>
      <BackButton
        to={`/offering?coachActivityId=${offering.data.coachActivityId}`}
      />
      <div className="p-6 text-center">
        <h1 className="text-2xl font-bold mb-2">{offering.data.name}</h1>
        <p className="text-muted-foreground">
          Manage your {offering.data.activity.title} availability.
        </p>
      </div>
      <EditOfferingSessionRuleSetForm />
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default EditOfferingSessionRuleSetPage;
